<div class="w-full h-full" fxLayout="row wrap">
    <mat-card class="mat-elevation-z4 m-auto" style="padding: 50px; max-width: 380px;">
        <mat-card-title class="text-center m-b-24">{{'logout.title' | translate}}!</mat-card-title>
        <mat-card-content class="text-center">
            <a mat-raised-button color="primary" href="/" >{{'logout.sign-in' | translate}}</a>
        </mat-card-content>
    </mat-card>
</div>